import API from '@/services/api';

// Actions
export const FETCH_PERMISSIONS = 'fetchRoles';

// Mutations
export const STORE_SET_PERMISSIONS = 'storeSetPermissions';

const state = {
    permissions: []
};

const getters = {
    permissions(state) {
        return state.permissions;
    }
};

const actions = {
    [FETCH_PERMISSIONS](context) {
        return new Promise((resolve, reject) => {
            API
                .query('permissions')
                .then((response) => {
                    context.commit(STORE_SET_PERMISSIONS, response.data);
                    resolve(response.data);
                })
                .catch((response) => {
                    reject(response);
                });
        });
    }
};

const mutations = {
    [STORE_SET_PERMISSIONS](state, permissions) {
        state.permissions = permissions;
    }
};

export default {state, getters, actions, mutations}